/**
 * Utility functions for culture by book data
 */

/**
 * Sort culture by book alphabetically by book name
 */
export function sortCultureByBook(
  items: CultureByBook[]
): CultureByBook[] {
  return [...items].sort((a, b) => (a.book || '').localeCompare(b.book || ''));
}

/**
 * Get culture by book data by book name
 */
export function getCultureByBookByBook(
  items: CultureByBook[],
  book: string
): CultureByBook | undefined {
  return items.find(item => item.book === book);
}

/**
 * Filter cultural themes by importance level
 */
export function filterBookCulturalThemesByImportance(
  culturalThemes: CultureByBook['culturalThemes'],
  importance: Importance
): CultureByBook['culturalThemes'] {
  return culturalThemes?.filter(theme => theme.importance === importance) || [];
}

/**
 * Get high importance items from book data
 */
export function getHighImportanceBookItems(
  cultureByBook: CultureByBook | undefined
): {
  culturalThemes: CultureByBook['culturalThemes'];
  terms: CultureByBook['commonTerms'];
} {
  if (!cultureByBook) {
    return { culturalThemes: [], terms: [] };
  }

  return {
    culturalThemes: cultureByBook.culturalThemes?.filter(t => t.importance === 'high') || [],
    terms: cultureByBook.commonTerms?.filter(t => t.importance === 'high') || []
  };
}

